import { render, staticRenderFns } from "./NewPaymentAddress.vue?vue&type=template&id=9d071aa6&"
import script from "./NewPaymentAddress.vue?vue&type=script&lang=js&"
export * from "./NewPaymentAddress.vue?vue&type=script&lang=js&"
import style0 from "./NewPaymentAddress.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports